import * as ActionTypes from './actionTypes'

export const myAction = (payload) => {
    return {
        type : ActionTypes.myActionType,
	payload
    }
}



// WEBPACK FOOTER //
// ./src/actions/actions.js


// WEBPACK FOOTER //
// webpack:///src/actions/actions.js